module.exports = __webpack_public_path__ + "img/spiral-details6.dc60c557.png";